import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

/**
 * Identifies the required physical additional column that stores an Event
 * Container's Organizational Unit.
 *
 * The referenced additional column is the single source of truth for this
 * semantic relationship. Valid OU template restrictions remain on the Event
 * Container template configuration.
 */
export type OttopilotOrganizationalUnitColumnConfig = {
    columnId: Uuid;
};

export const ottopilotOrganizationalUnitColumnConfigValidator: zod.ZodType<OttopilotOrganizationalUnitColumnConfig> = zod.strictObject({
    columnId: uuidZodValidator,
});

export function getOttopilotOrganizationalUnitValue(
    entity: {additionalColumnValues: Readonly<Record<Uuid, unknown>>},
    configuration: OttopilotOrganizationalUnitColumnConfig,
): Uuid {
    return uuidZodValidator.parse(entity.additionalColumnValues[configuration.columnId]);
}

export function getOptionalOttopilotOrganizationalUnitValue(
    entity: {additionalColumnValues: Readonly<Record<Uuid, unknown>>},
    configuration: OttopilotOrganizationalUnitColumnConfig,
): Uuid | null {
    const result = uuidZodValidator.safeParse(entity.additionalColumnValues[configuration.columnId]);
    return result.success === true ? result.data : null;
}
